<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Actualizar rol y permiso</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="UPDATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar cambios</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid vstack gap-5">
                    <div class="col-12" v-if="loading">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-md-6">
                            <div>
                                <label class="input-title">Nombre</label>
                                <label class="form-control form-control-sm readonly">{{  data.name }}</label>
                            </div>
                            <div>
                                <label class="input-title">Icono</label>
                                <input type="text" class="form-control form-control-sm" v-model="data.icon"
                                    :class="errors.icon ? 'is-invalid' : ''">
                                <small class="invalid-feedback" v-for="(error, index) in errors.icon" :key="index">{{
                                    error
                                }}</small>
                            </div>
                            <div>
                                <label class="input-title">Descripción</label>
                                <textarea class="form-control form-control-sm" rows="5" v-model="data.description"
                                    :class="errors.description ? 'is-invalid' : ''"></textarea>
                                <small class="invalid-feedback" v-for="(error, index) in errors.description"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="list-group list-group-flush gap-3">
                                <div class="list-group-item p-6 bg-white border rounded-2">
                                    <div class="d-flex">
                                        <div class="w-10"><i class="bi bi-people text-lg text-muted"></i></div>
                                        <div class="flex-1 me-10">
                                            <span class="d-block h5 text-primary-hover">Permisos</span>
                                            <p class="mt-1 text-sm text-muted mb-0">Seleccione los permisos que desea
                                                agregar.</p>
                                        </div>
                                    </div>
                                    <div class="vstack gap-2 mt-3 ms-10">
                                        <v-treeview
                                            v-model="data.treeview"
                                            :items="permissions"
                                            :open.sync="open"
                                            selectable
                                            open-on-click
                                            item-key="id"
                                            dense>
                                            <template v-slot:prepend="{ item, open }">
                                                <i :class="item.file" style="font-size: 12px;"></i>
                                            </template>
                                        </v-treeview>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
export default {
    data() {
        return {
            permissions: [],
            open: [0],
            data: {},
            errors: {},
            count: 0,
            id: this.$route.params.id,
            loading: true
        }
    },
    mounted() {
        this.PERMISSION()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/roles/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        UPDATE: function () {
            let vue = this
            vue.count++
            vue.errors = {}
            if (vue.count == 1) {
                setTimeout(() => {
                    axios({ url: '/roles/' + vue.id, method: 'PUT', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'RoleIndex' });
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
                }, 1000)
            }
        },
        PERMISSION: function(){
            let vue = this
            axios({ url: '/permissions', method: 'GET' })
            .then((resp) => {
                vue.permissions = resp.data
            })
            .finally((resp) => {
                vue.loading = false
                vue.INIT()
            })
        }
    },
}
</script>